import { getMakeAPI, Method } from '@golden/getch';
import { map } from 'rxjs';
import { convertUnixToDate } from '@golden/utils';
const makeAPI = getMakeAPI('v1');
const makePlayerAPI = getMakeAPI('player/v1');
export const ACTIVITY_API = {
    GET_ACTIVITY_LIST: makeAPI(Method.GET, '/activities')(),
    GET_INVITE_FRIEND: makeAPI(Method.GET, '/activity/invite-friend')(),
    GET_INVITE_FRIEND_INVITE_CODE_INFO: makeAPI(Method.GET, '/activity/invite-friend/invite-code-info')(),
    GET_MY_INVITE_INFO: makePlayerAPI(Method.GET, '/activity/invite-friend/my-invite-info')(),
    POST_INVITE_FRIEND_BIND_FRIEND: makePlayerAPI(Method.POST, '/activity/invite-friend/bind-friend')(),
    POST_UPGRADE_BONUS: makePlayerAPI(Method.POST, '/activity/upgrade-bonus')(),
    GET_WEEKLY_BONUS_INFO: makeAPI(Method.GET, '/activity/weekly-bonus')(),
    POST_WEEKLY_BONUS: makePlayerAPI(Method.POST, '/activity/weekly-bonus/get-bonus')(),
    POST_BIRTHDAY_BONUS: makePlayerAPI(Method.POST, '/activity/birthday-bonus')(),
    GET_FEEDBACK_BONUS_INFO: makePlayerAPI(Method.GET, '/activity/feedback')(),
    POST_FEEDBACK_BONUS: makePlayerAPI(Method.POST, '/activity/feedback')(),
    GET_INVITE_FRIEND_BONUS: makePlayerAPI(Method.GET, '/activity/invite-friend/bonus')(),
    POST_INVITE_FRIEND_CLAIM_REWARDS: makePlayerAPI(Method.POST, '/activity/invite-friend/claim-rewards')(),
    GET_PREDICTION_MATCHES: makePlayerAPI(Method.GET, '/activity/prediction/fifa-2026/matches')(),
    GET_PREDICTION_RECORD: makePlayerAPI(Method.GET, '/activity/prediction/fifa-2026/record')(),
    GET_PREDICTION_RANK: makePlayerAPI(Method.GET, '/activity/prediction/fifa-2026/ranking')(),
    POST_PREDICTION_MATCH: makePlayerAPI(Method.POST, '/activity/prediction/fifa-2026/predict')(),
    POST_PREDICTION_PAYOUT_CLAIM: makePlayerAPI(Method.POST, '/activity/prediction/fifa-2026/payout/{id}/claim')(),
    POST_PREDICTION_PAYOUT_CLAIM_ALL: makePlayerAPI(Method.POST, '/activity/prediction/fifa-2026/payout/claim-all')(),
    GET_PREDICTION_VALIDATION: makePlayerAPI(Method.GET, '/activity/prediction/fifa-2026/eligibility')(),
    GET_PREDICTION_STREAMERS: makePlayerAPI(Method.GET, '/activity/prediction/fifa-2026/streamer-tasks/live')()
};
export const RANK_BONUS_API = {
    GET_RANK_BONUS_INFO: makeAPI(Method.GET, '/activity/rank-bonus')(),
    GET_UPGRADE_SETTINGS: makePlayerAPI(Method.GET, '/activity/rank-bonus/upgrade-settings')()
};
export function createBaseActivityService(api, readonly) {
    return {
        getList(data) {
            const { is_carousel, is_my } = data;
            return api.fetch(ACTIVITY_API.GET_ACTIVITY_LIST, { data: { ...is_carousel !== undefined ? { is_carousel } : {}, ...is_my !== undefined ? { is_my } : {} } }).pipe(map((data) => ({ ...data, activities: data.activities.map((el) => convertUnixToDate(el, 'start_at', 'end_at', 'show_start_at', 'show_end_at')) })));
        },
        getMyInviteInfo() {
            return api.fetch(ACTIVITY_API.GET_MY_INVITE_INFO);
        },
        getInviteFriend() {
            return api.fetch(ACTIVITY_API.GET_INVITE_FRIEND).pipe(map((data) => convertUnixToDate(data, 'start_at', 'end_at', 'show_start_at', 'show_end_at')));
        },
        getInviteFriendInviteCodeInfo(invite_code) {
            return api.fetch(ACTIVITY_API.GET_INVITE_FRIEND_INVITE_CODE_INFO, { data: { invite_code } });
        },
        ...(!readonly && {
            getUpgradeSettings() {
                return api.fetch(RANK_BONUS_API.GET_UPGRADE_SETTINGS);
            },
            getRankBonusInfo() {
                return api.fetch(RANK_BONUS_API.GET_RANK_BONUS_INFO).pipe(map((data) => convertUnixToDate(data, 'start_at', 'end_at')));
            },
            applyUpgradeBonus() {
                return api.fetch(ACTIVITY_API.POST_UPGRADE_BONUS);
            },
            getWeeklyBonusInfo() {
                return api.fetch(ACTIVITY_API.GET_WEEKLY_BONUS_INFO);
            },
            applyWeeklyBonus() {
                return api.fetch(ACTIVITY_API.POST_WEEKLY_BONUS);
            },
            applyBirthdayBonus() {
                return api.fetch(ACTIVITY_API.POST_BIRTHDAY_BONUS);
            },
            getFeedbackBonusInfo() {
                return api.fetch(ACTIVITY_API.GET_FEEDBACK_BONUS_INFO);
            },
            applyFeedbackBonus() {
                return api.fetch(ACTIVITY_API.POST_FEEDBACK_BONUS);
            },
            bindInviteFriend(data) {
                return api.fetch(ACTIVITY_API.POST_INVITE_FRIEND_BIND_FRIEND, { data });
            },
            getInviteFriendBonus() {
                return api.fetch(ACTIVITY_API.GET_INVITE_FRIEND_BONUS);
            },
            claimInviteFriendRewards() {
                return api.fetch(ACTIVITY_API.POST_INVITE_FRIEND_CLAIM_REWARDS);
            },
            getPredictionMatches() {
                return api.fetch(ACTIVITY_API.GET_PREDICTION_MATCHES).pipe(map(data => data.map(item => convertUnixToDate(item, 'started_at', 'ended_at', 'prediction_closed_at'))));
            },
            getPredictionRecord() {
                return api.fetch(ACTIVITY_API.GET_PREDICTION_RECORD).pipe(map(data => ({ ...data, predictions: data.predictions.map(item => ({ ...item, match: convertUnixToDate(item.match, 'started_at', 'ended_at', 'prediction_closed_at') })) })));
            },
            getPredictionRank() {
                return api.fetch(ACTIVITY_API.GET_PREDICTION_RANK);
            },
            postPredictionMatch(data) {
                return api.fetch(ACTIVITY_API.POST_PREDICTION_MATCH, { data });
            },
            postPredictionPayoutClaim(id) {
                return api.fetch(ACTIVITY_API.POST_PREDICTION_PAYOUT_CLAIM, { config: { urlParams: { id } } });
            },
            postPredictionPayoutClaimAll() {
                return api.fetch(ACTIVITY_API.POST_PREDICTION_PAYOUT_CLAIM_ALL);
            },
            getPredictionValidation() {
                return api.fetch(ACTIVITY_API.GET_PREDICTION_VALIDATION);
            },
            getPredictionStreamers() {
                return api.fetch(ACTIVITY_API.GET_PREDICTION_STREAMERS);
            }
        })
    };
}
//# sourceMappingURL=ActivityService.js.map